export enum Country {
  Australia = "AU",
  NewZealand = "NZ"
}
